import React from 'react';
import { User } from 'features/users/types';
import { StreamBadge } from 'features/streaming/components/stream-display/StreamBadge';
import { useVisibleUserBadges } from 'features/streaming/hooks/useVisibleUserBadges';
import { useAppSelector } from 'store/hooks';
import { selectVideoTileLayoutMode } from 'features/layout/features/config/configSlice';
import { VideoTileLayoutMode } from 'features/layout/types';

type UserStreamBadgeProps = {
  label?: string | null;
  user: User;
  className?: string;
};

export const UserStreamBadge = ({ label, user, className }: UserStreamBadgeProps) => {
  const { count: badgeCount } = useVisibleUserBadges(user);
  const layout = useAppSelector(selectVideoTileLayoutMode);
  const isBottom = layout === VideoTileLayoutMode.bottom;

  return (
    <StreamBadge
      label={label}
      badgeCount={isBottom ? undefined : badgeCount}
      layout={layout}
      className={className}
    />
  );
};
